module.exports = __webpack_public_path__ + "static/bg1-e72ef4aaf0c679fd64f0d00e102b543f.png";